import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

const InventoryIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <g
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M3.5 7.5 12 3l8.5 4.5v10L12 22l-8.5-4.5z" />
      <path d="M3.5 7.5 12 12l8.5-4.5M12 12v10M8 5.2l8.5 4.5v3.5" />
    </g>
  </SvgIcon>
)

export default InventoryIcon
